import React from 'react';
import { PropTypes } from 'prop-types';

import WelcomeSection from '../components/project-survey-welcome-section';
import EndScreenSection from '../components/project-survey-end-screen-section';
import SurveysPagesSection from '../components/project-surveys-pages';

const ProjectSurveySummary = (props) => {
  const {
    edit,
    baseUrl,
    history,
    values,
    smallColumn,
  } = props;

  return (
    <>
      <WelcomeSection
        baseUrl={baseUrl}
        history={history}
        values={values}
        smallColumn={smallColumn}
      />

      {values.surveysPages && (
        values.surveysPages.map((surveyPage) => (
          <SurveysPagesSection
            baseUrl={baseUrl}
            history={history}
            values={surveyPage}
            smallColumn={smallColumn}
            edit={edit}
          />
        ))
      )}

      <EndScreenSection
        baseUrl={baseUrl}
        history={history}
        values={values}
        smallColumn={smallColumn}
      />
    </>
  );
};

ProjectSurveySummary.propTypes = {
  edit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    welcomeContent: PropTypes.string,
    welcomeTitle: PropTypes.string,
    textEndScreen: PropTypes.string,
    endScreenTitle: PropTypes.string,
    surveysPages: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  baseUrl: PropTypes.string,
  smallColumn: PropTypes.bool,
};

ProjectSurveySummary.defaultProps = {
  baseUrl: undefined,
  history: {},
  smallColumn: false,
};

export default ProjectSurveySummary;
